import { faCopy, faInr } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Grid, Button, Link } from '@mui/material'
import React, { useState, useEffect } from 'react'
import ImageComponents from '../../../../Shared/ImageComponents';
import getDomain from '../../Components/getDomain';
import Loader from '../../Components/loader';

function NeftImps({ payModesToPass }) {

    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [accountNo, setAccountNo] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [showLoader, setshowLoader] = useState(false);



    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
         // console.log("Copied");
        }).catch((err) => {
          console.error("Failed to copy: ", err);
        });
      };

      const handlePrintAction = () => {
        setLoading(true);
        const queryParameters = new URLSearchParams(window.location.search);
        const orderNo = queryParameters.get('orderNo');
        const encodedOrderNo = encodeURIComponent(orderNo);
        const domain = getDomain();
        const url =  domain + `/pay/download/accountPdf?orderNo=${encodedOrderNo}`;
        console.log(url);
 
        window.location.href = url;
        setLoading(false);
      };


    const handleButtonClick = () => {
        setShowDetails(true);
    };

    const handlePayment = async () => {
        setshowLoader(true);
        try {
            const queryParameters = new URLSearchParams(window.location.search);
            const secureVar1 = queryParameters.get('var1');
            const secureVar2 = queryParameters.get('var2');
            const orderNo = queryParameters.get('orderNo');
            const displayOrderNo = queryParameters.get('orderNo');

            console.log("secureVar1: " + secureVar1);
            console.log("secureVar2: " + secureVar2);
            console.log("orderNo: " + orderNo);
            const response = await fetch(`/pay/process/intermediate/payment?var1=${secureVar1}&var2=${secureVar2}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    mode: 'SMARTCOLLECT',
                    orderNo: orderNo,
                    displayOrderNo: displayOrderNo,
                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();

            console.log("Response status: " + String(result.data.ok));


            if (result.data.ok === '1') {
                setIfscCode(result.data.ifscCode);
                setAccountNo(result.data.accountNo);
            }
            setshowLoader(false);
            console.log("details fetched!");
            setShowDetails(true);
        } catch (error) {
            console.error('API request error:', error);
        } finally {
            setLoading(false);
        }
    }


    return (
        <div className='card-details pos'>
            {showDetails ? (
                <div>
                    <div className='card-detail-form'>
                        <h3>Pay using NEFT/IMPS/RTGS</h3>
                        <div className='amount-payble'>
                            <p>
                                Amount payable is: <FontAwesomeIcon icon={faInr} />{payModesToPass.txAmount}
                            </p>
                        </div>
                    </div>
                    <p>
                        To complete the transaction, make transfer to below account:
                    </p>
                    <div className='transacton-table-list'>
                        <ul>
                            <li>
                                <span>Account no:</span>
                            </li>
                            <li>
                                <b>{accountNo}</b>
                            </li>
                            <li>
                                <Button onClick={() => handleCopy(accountNo)}><ImageComponents name={'copyBtn'} /></Button>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span>IFSC:</span>
                            </li>
                            <li>
                                <b>{ifscCode}</b>
                            </li>
                            <li>
                                <Button onClick={() => handleCopy(ifscCode)}><ImageComponents name={'copyBtn'} /></Button>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span>Beneficiary name:</span>
                            </li>
                            <li>
                                <b style={{ whiteSpace: 'nowrap' }}>Policybazaar Insurance</b>
                            </li>
                            <li>
                                <Button onClick={() => handleCopy('Policybazaar Insurance')}><ImageComponents name={'copyBtn'} /></Button>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span>Amount expected:</span>
                            </li>
                            <li>
                                <b><FontAwesomeIcon icon={faInr} />{payModesToPass.txAmount}</b>
                            </li>
                        </ul>
                    </div>
                    <div className='pay-using-error-box'>
                        <p>
                            Do not round off the amount. Transfer the exact amount for the payment to be successful. Please make Payment only in the account number mentioned in the challan.
                        </p>
                    </div>
                    <Link component="button" onClick={handlePrintAction}>Print details</Link>
                </div>

            ) : (
                <div className='card-detail-form'>
                    <h3>Pay using NEFT/IMPS/RTGS</h3>
                    <div className='amount-payble'>
                        <p>
                            Amount payable is: <FontAwesomeIcon icon={faInr} />{payModesToPass.txAmount}
                        </p>
                    </div>
                    <p className='mt-2 mb-2'>
                        To complete the transaction, make NEFT/IMPS/RTGS transfer to:
                    </p>
                    <Button onClick={handlePayment} variant="outlined" size="large" className='pay-now-btn' style={{ width: '250px' }} >
                        Show account details
                    </Button>
                </div>
            )}
        </div>
    );
}


export default NeftImps
